<h2>{{'Tools' | titlecase}}</h2>

<app-buttons [buttons]="getButtonsMeta()"
             (buttonPressed)="controlButtonPressed($event)"
             [targetSelected]="true">
</app-buttons>
